import { ICellRendererParams, IRowNode } from "@ag-grid-community/core";
import { GenericTableCell } from "gen/model/genericTableCell";
import { GenericTableRow } from "gen/model/genericTableRow";
import React from "react";
import { DataTableContext } from "shared/components/table/data/DataTableContext";
import { isTotalRow } from "shared/components/table/data/DataTableTypes";
import { DataTableCellContentRenderer } from "shared/components/table/data/internal/DataTableCellContentRenderer";
import { DataTableChildCount } from "shared/components/table/data/internal/DataTableChildCount";
import { useBuildDataTableColumnContext } from "shared/components/table/data/internal/DataTableContextBuilders";
import { valueForCell } from "shared/components/table/data/internal/DataTableInternalUtils";

export const DataTableAutoGroupColumnCell: React.FC<
  ICellRendererParams<GenericTableRow, GenericTableCell, DataTableContext>
> = (props) => {
  if (isTotalRow(props.node.data) || !props.node.group) {
    return valueForCell(props.value);
  }
  return <DataTableAutoGroupColumnCellRenderer {...props} />;
};

const DataTableAutoGroupColumnCellRenderer: React.FC<
  ICellRendererParams<GenericTableRow, GenericTableCell, DataTableContext>
> = (props) => {
  const { node, context, valueFormatted } = props;

  const column = node.rowGroupColumn!;
  const leafRow = (
    node.allLeafChildren as IRowNode<GenericTableRow>[] | undefined
  )?.[0];
  const cell = leafRow?.data?.cells[column.getColId()];

  const columnContext = useBuildDataTableColumnContext(context, column);

  if (!cell) {
    // this happens when pivoting is enabled
    return <div className="mb-dt-cell-content">{valueFormatted}</div>;
  }

  return (
    <>
      <DataTableCellContentRenderer
        tableContext={context}
        columnContext={columnContext}
        row={leafRow}
        cell={cell}
        params={props}
      />
      <DataTableChildCount {...props} />
    </>
  );
};
